import { apiGet } from "./http";

export interface PlatformDashboardMetrics {
  tenantTotal: number;
  activeTenants: number;
  pendingTenants: number;
  totalMembers: number;
  totalMonthlyActiveUsers: number;
  newTenantsThisMonth: number;
  newMembersThisMonth: number;
  generatedAtUtc: string;
}

export function fetchPlatformDashboardMetrics(): Promise<PlatformDashboardMetrics> {
  return apiGet<PlatformDashboardMetrics>("/api/platform/dashboard-metrics");
}
